import {
  TENANT_AT,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts/tenants'
import type { Tenant } from 'types/shopConfig'

export const ACTIVE_TENANTS: Tenant[] = [
  TENANT_COM,
  TENANT_AT,
  TENANT_CH,
  TENANT_FR,
  TENANT_IT,
]
